<td>
  <span class="flex gap-2 align-items-center"
    ><i class="fas fa-thumb-tack"></i> {{ item.name }}</span
  >
</td>
<td>
  <span class="flex gap-2">
    <p-button
      styleClass="p-button-xs"
      (click)="openInAtlas(item)"
      [pTooltip]="'Im Vergleichsbericht öffnen'"
      [rounded]="true"
      icon="fas fa-clipboard-list"></p-button>
  </span>
</td>
